import React, { Component } from 'react'

export default class GetMobileApp extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  
  androidBadge(androidActImage) {

    return (
      <a href="https://play.google.com/store/apps/details?id=com.barrigroup.barrimobile.a01&referrer=utm_source%3Dbfg-it-3%26utm_medium%3Dwpm%26utm_term%3Dsend%252Bmoney%26utm_content%3Dc01%26utm_campaign%3Dmbt"
        target="_blank"
        className=""
      >
        <img src={androidActImage}
          width="auto" height="40"
          className="img-responsive center-block"
          style={{
            "height": "40px"
          }}
          alt="Get it on Google Play"
        />
      </a>
    )
  }

  iosBadge(appleActImage) {
    return (
      <a href="https://itunes.apple.com/app/apple-store/id1291545810?pt=118817520&ct=bfg-it-3&mt=8"
        target="_blank"
        className=""
      >
        <img src={appleActImage}
          width="auto" height="40"
          className="img-responsive center-block"
          style={{
            "height": "40px"
          }}
          alt="Download on the App Store"
        />
      </a>
    )
  }

  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;


    // if (/windows phone/i.test(userAgent)) {
    //   return "Windows Phone";
    // }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return false;
  }


  componentDidMount() {
    this.setState({
      mobOP: this.getMobileOperatingSystem()
    })
  }


  render() {
    var androidActImage = 'img/android/google-play-badge-es.png';
    var appleActImage = 'img/apple/Download_on_the_App_Store_Badge_ES_RGB_blk_100217.svg';

    if (this.props.locale != 'es') {
      androidActImage = "img/android/google-play-badge.png";
      appleActImage = 'img/apple/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';
    }

    // let text = "Descarga nuestra App para Android";
    let textsMap = langMap[this.props.locale] || {};

    let text = this.state.mobOP == "Android"? textsMap["getAppAndroid"]:
    this.state.mobOP == "iOS"? textsMap["getAppiOS"]:"";

    // let badge = this.androidBadge(androidActImage);
    
    let badge = this.state.mobOP == "Android" ? this.androidBadge(androidActImage) :
              this.state.mobOP == "iOS" ? this.iosBadge(appleActImage) : null

    return this.state.mobOP? (
      <div className="alert alert-info alert-dismissible getMobileApp" role="alert" style={css.alert}>
        <button type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>

        <div className="text-center">
          <strong>{text}</strong>
        </div>
        <div style={{ marginTop: "5px" }}>
          {
            badge
          }
        </div>
      </div>
    ): null
  }
}

let css = {
  alert: {
    position: "fixed",
    top: "5px",
    zIndex: "100",
    left: "8px",
    width: "100%",
    paddingTop: "5px",
    paddingBottom: "5px"
  }
}

let langMap = {
  en: {
    getAppiOS: "Download our App for iOS",
    getAppAndroid: "Download our App for Android",
  },
  es: {
    getAppiOS: "Descarga nuestra App para iOS",
    getAppAndroid: "Descarga nuestra App para Android",
  },
}



// WEBPACK FOOTER //
// ./js/GetMobileApp.js